import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7AEBE",
      "fill-rule": "evenodd",
      d: "M10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM5.834 5a4.167 4.167 0 1 1 8.333 0 4.167 4.167 0 0 1-8.333 0Zm-.14 7.658c-1.085.611-1.527 1.325-1.527 1.925 0 1.108.045 1.614.526 2.006.273.222.753.458 1.618.633.862.174 2.051.278 3.69.278 1.637 0 2.826-.104 3.688-.278.866-.175 1.345-.411 1.618-.633.482-.392.527-.898.527-2.006 0-.6-.442-1.314-1.528-1.925-1.06-.596-2.58-.991-4.306-.991-1.725 0-3.245.395-4.305.991Zm-.816-1.453C6.23 10.445 8.043 10 10 10c1.957 0 3.77.444 5.123 1.205 1.327.747 2.377 1.908 2.377 3.378v.102c.002.956.004 2.264-1.14 3.196-.56.457-1.33.77-2.34.974-1.013.206-2.325.312-4.02.312-1.695 0-3.006-.107-4.02-.312-1.009-.204-1.779-.517-2.34-.974-1.143-.932-1.141-2.24-1.14-3.196v-.102c0-1.47 1.05-2.631 2.378-3.378Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "User"}) } }